import {
  getSiteCollectionAnalyze,
  getComponentFilter,
  getAutoUpdate,
  getSiteCollectionList,
  getSiteCollectionAutoUpdate,
  getSiteCollectionBatchSite,
  getSiteCollectionAddSite,
} from '@/api/account-center/site-collect'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { t } from '@/i18n'

// 站点收集分析
export const useGetSiteCollectionAnalyze = () => {
  const { runAsync: run, data } = useRequest(() => getSiteCollectionAnalyze(), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || t('获取站点收集分析失败'))
    },
  })

  return [data?.data || {}, run] as const
}

// 站点收集列表
export const useGetSiteCollectionList = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(doc => getSiteCollectionList(doc), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取站点收集列表失败'))
    },
  })

  return [data?.data || {}, run, loading] as const
}

// 筛选组件数据
export const useGetComponentFilter = () => {
  const { runAsync: run, data } = useRequest(() => getComponentFilter(), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || t('获取筛选组件数据失败'))
    },
  })

  return [data?.data?.list || [], run] as const
}

// 获取自动更新状态
export const useGetAutoUpdate = () => {
  const { runAsync: run, data } = useRequest(() => getAutoUpdate(), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || t('获取自动更新状态失败'))
    },
  })

  return [data?.data || {}, run] as const
}

// 修改自动更新状态
export const useGetSiteCollectionAutoUpdate = () => {
  const { runAsync: run, data } = useRequest(doc => getSiteCollectionAutoUpdate(doc), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('修改自动更新状态失败'))
    },
  })

  return [data?.data || {}, run] as const
}

// 站点收集批量添加站点
export const useGetSiteCollectionBatchSite = () => {
  const { runAsync: run, data } = useRequest(doc => getSiteCollectionBatchSite(doc), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('批量添加站点失败'))
    },
  })

  return [data?.data || {}, run] as const
}

// 站点收集添加站点
export const useGetSiteCollectionAddSite = () => {
  const { runAsync: run, data } = useRequest(doc => getSiteCollectionAddSite(doc), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || t('添加站点失败'))
    },
  })

  return [data?.data || {}, run] as const
}
